module.exports = __webpack_public_path__ + "static/media/surgeryInstructions.e1f35c7c.mp3";